<template>
  <nav class="nav">
    <ul class="nav__list">
      <li v-for="route in navRoutes" :key="route.name" class="nav__item">
        <nuxt-link
          class="nav__link"
          :to="localePath(route.url)"
        >
          <span>{{ $t(route.label) }}</span>
          <icon class="nav__icon" icon="forward-ios"/>
        </nuxt-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import { CONSTANTS } from '@sohohouse/platform-resources'
import { SETTINGS_NAV_ROUTES } from '~/constants'
import Icon from '~/components/icon'

export default {
  components: {
    Icon
  },

  data () {
    return {
      SETTINGS_NAV_ROUTES
    }
  },

  computed: {
    ...mapGetters(['currentUser']),

    navRoutes () {
      const { nonMemberAccount, subscriptionType } = this.currentUser.membership
      const nonMemberRoutes = ['preferences', 'logout']
      const nonHouseMemberOnlyRoutes = ['applications']
      const houseMemberOnlyRoutes = ['houses', 'previous-bookings', 'member-benefits']

      const isFriend = subscriptionType === CONSTANTS.SUBSCRIPTION_TYPES.FRIENDS

      return SETTINGS_NAV_ROUTES.filter(({ name }) => {
        // Regular house member, remove nonHouseMemberOnlyRoutes
        if (!nonMemberAccount && !isFriend) {
          return !nonHouseMemberOnlyRoutes.includes(name)
        }
        // Non member account, remove everything but nonMemberRoutes and nonHouseMemberOnlyRoutes
        if (nonMemberAccount) {
          return nonMemberRoutes.includes(name) || nonHouseMemberOnlyRoutes.includes(name)
        }

        if (isFriend) {
          return !houseMemberOnlyRoutes.includes(name)
        }

        return true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.nav {
  &__list {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  &__item {
    display: flex;
    align-items: center;
    margin: $space-060 0;
  }

  &__link {
    @include font('050');

    display: flex;
    width: 100%;
    align-content: center;
    text-decoration: none;

    &.nuxt-link-active {
      span {
        @include underline;
      }
    }

    span {
     color: $color-black;
    }
  }

  &__icon {
    margin-left: auto;
  }
}
</style>
